export const REQUESTED_VALIDATE = `REQUESTED_VALIDATE`
export const REQUESTED_VALIDATE_SUCCEEDED = `REQUESTED_VALIDATE_SUCCEEDED`
export const REQUESTED_VALIDATE_FAILED = `REQUESTED_VALIDATE_FAILED`
